import React from 'react';
import { CloseIcon } from '../../assets/icons';
import cx from 'classnames';
import toast from 'react-hot-toast';
import { VendorT } from '../../types';
import CreateVendorForm from './Createvendor';
import { createVendor } from '../../backend-services/vendor';
import { IVendor } from '../../@types';

interface CreateVendorProps {
  onVendorCreate?: (vendor: any) => void;
  show: boolean;
  onClose?: () => void;
}

const AddVendors = ({ onVendorCreate, show, onClose }: CreateVendorProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');

  const handleCreateVendor = async (vendor: VendorT) => {
    setIsLoading(true);
    setErrorMessage('');
    try {
      const data = await createVendor({
        ...vendor,
        phone: vendor.phone ?? undefined,
        
      });
      setIsLoading(false);
      setIsOpen(false);
      toast.success('Vendor created successfully!');
      onVendorCreate &&
        onVendorCreate({
          id: data.id,
          name: data.name,
           phone: data.phone,
          address: data.address,
        });
      onClose && onClose();
    } catch (error:any) {
      console.log(error.message);
      if (error.message) {
        setErrorMessage('Error: ' + error.message);
      } else {
        setErrorMessage('');
      }
      setIsLoading(false);
    }
  };
  const handleClose = () => {
    setIsOpen(false);
    onClose && onClose();
  };

  React.useEffect(() => {
    setIsOpen(show);
  }, [show]);

  return isOpen ? (
    <>
      {/* Modal Background */}
      <div
        aria-hidden="false"
        className="fixed top-0 right-0 left-0 z-50 h-[400vh] overflow-y-auto overflow-x-hidden items-start flex bg-gray-900 bg-opacity-50"
      >
        <div
          className={cx({
            'relative z-50 h-[400vh] w-full': true,
            'p-3 max-w-lg bg-white shadow': true,
            'animate-slide-in': isOpen,
          })}
        >
          <div className="flex items-start justify-between p-3">
            <h3 className="text-[25px] font-bold ">{'Add New Vendor'}</h3>
            <button
              aria-label="Close"
              className="ml-auto inline-flex items-center rounded-lg bg-transparent text-red-400"
              type="button"
              onClick={handleClose}
            >
              <CloseIcon />
            </button>
          </div>

          {/* MODAL BODY */}
          <div className="p-4 pt-10">
          {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            <CreateVendorForm
              isLoading={isLoading}
              show={true}
              onSubmit={handleCreateVendor}
              buttontitle={'Add Vendor'} setFormData={function (value: React.SetStateAction<IVendor>): void {
                throw new Error('Function not implemented.');
              } }              // errorMessage={errorMessage} 
            />
          </div>
        </div>
      </div>
    </>
  ) : null;
};

export { AddVendors };
